var map = {
	"./BrandKit.js": "7114",
	"./Launchpad.js": "c241",
	"./Markets.json": "11d2",
	"./Transacting.js": "749e",
	"./about.js": "dcb7",
	"./actPage.js": "2005",
	"./ambassador.js": "a69e",
	"./anti-fake.js": "25e2",
	"./api.js": "29c8",
	"./blog.js": "aa34",
	"./business-verification.js": "8abe",
	"./buy_crypto.js": "3e52",
	"./capital_flow.js": "eedd",
	"./certification.json": "e643",
	"./common.js": "d977",
	"./coupon.js": "384a",
	"./dao.js": "dcd0",
	"./deposit.js": "a0bd",
	"./download.js": "a175",
	"./earn.js": "89a2",
	"./footer.js": "ff30",
	"./futures.js": "6837",
	"./home.js": "5e1b",
	"./ieo.js": "a3ac",
	"./index.js": "a9fb",
	"./invitation.js": "a806",
	"./labs.json": "518f",
	"./listings.js": "c1d7",
	"./nft.js": "6f5b",
	"./novice.js": "f856",
	"./other.js": "d5f6",
	"./sign.json": "66f3",
	"./tip.js": "1bbd",
	"./transferModal.js": "dfd0",
	"./union-referral.js": "cf00",
	"./user-center.js": "7d0b",
	"./withdraw.json": "4375"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c58";